(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hmtc-still-dangerous-header"]) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('.sd-number-search')) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;
    const status = form.querySelector('[role="status"]');
    const prefix = form.dataset.productPrefix + form.elements.number.value;
    const sleeves = form.dataset.sleeve ? [form.dataset.sleeve] : ['short', 'long'];
    button.disabled = true;
    status.textContent = '';

    try {
      for (const sleeve of sleeves) {
        const url = prefix + '-' + sleeve + '-sleeve';
        const response = await fetch(url + '.js');
        if (response.ok) {
          window.location.assign(url);
          return;
        }
        if (response.status !== 404) throw new Error('Product lookup failed');
      }
      status.textContent = status.dataset.missing;
    } catch {
      status.textContent = status.dataset.error;
    } finally {
      button.disabled = false;
    }
  });
  document.addEventListener('formdata', (event) => {
    if (!event.target.matches('.sd-jersey-search')) return;
    const player = event.formData.get('q').trim();
    event.formData.set('q', player + ' jersey number');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
